// javascript
  import { useEffect, useState } from 'react';
  import { Outlet } from 'react-router-dom';
  import { useDispatch, useSelector } from 'react-redux';
  // material-ui
  import { useTheme } from '@mui/material/styles';
  import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

  // project import
  import Drawer from './Drawer';
  import Header from './Header';
  import Footer from './Footer';
  import HorizontalBar from './Drawer/HorizontalBar';
  import Breadcrumbs from 'components/@extended/Breadcrumbs';

  import navigation from 'menu-items';
  import useConfig from 'hooks/useConfig';
  import { openDrawer } from 'store/reducers/menu';
  import { LAYOUT_CONST } from 'config';

  // ==============================|| MAIN LAYOUT ||============================== //

  const MainLayout = () => {
    const theme = useTheme();
    const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
    const downLG = useMediaQuery(theme.breakpoints.down('lg'));

    const { container, miniDrawer, menuOrientation } = useConfig();
    const dispatch = useDispatch();

    const menu = useSelector((state) => state.menu);
    const { drawerOpen } = menu;

    const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

    // drawer toggler — use functional update to reliably compute next state and dispatch it
    const [open, setOpen] = useState(!miniDrawer || drawerOpen);
    const handleDrawerToggle = () => {
      setOpen((prev) => {
        const next = !prev;
        dispatch(openDrawer({ drawerOpen: next }));
        return next;
      });
    };

    // set media wise responsive drawer
    useEffect(() => {
      if (!miniDrawer) {
        setOpen(!matchDownLG);
        dispatch(openDrawer({ drawerOpen: !matchDownLG }));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownLG]);

    useEffect(() => {
      if (open !== drawerOpen) setOpen(drawerOpen);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerOpen]);

    return (
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header open={open} handleDrawerToggle={handleDrawerToggle} />
        {!isHorizontal ? <Drawer open={open} handleDrawerToggle={handleDrawerToggle} /> : <HorizontalBar />}

        <Box component="main" sx={{ width: open ? 'calc(100% - 260px)' : '100%', flexGrow: 1 }}>
          <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
          <Container
            maxWidth={container ? 'xl' : false}
            sx={{
              ...(container && { px: { xs: 0, sm: 2 } }),
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'Flex',
              flexDirection: 'column',
              padding: '0',
            }}
          >
            <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />
            <Outlet />
            <Footer />
          </Container>
        </Box>
      </Box>
    );
  };

  export default MainLayout;